import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import skype from '../assets/skype.png';

const images = {
  email,
  mobile,
  cpp,
  css,
  flutter,
  git,
  html,
  javascript,
  node,
  react,
  sass,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  skype,
};

export default images;